import { allTags, tagCounts } from '@/content/projects'
import type { Tag } from '@/types/content'
import styles from './ProjectFilter.module.css'

interface ProjectFilterProps {
  active: Tag | null
  onChange: (tag: Tag | null) => void
  total: number
}

/**
 * The filter row is derived from the project data — a new tag on any project
 * shows up here automatically. (The old site linked a `filter.js` that was never
 * written; this is that feature, driven by types instead of DOM queries.)
 */
export function ProjectFilter({ active, onChange, total }: ProjectFilterProps) {
  return (
    <div className={styles.bar} role="group" aria-label="Filter projects by category">
      <button
        type="button"
        className={styles.chip}
        data-active={active === null}
        aria-pressed={active === null}
        onClick={() => onChange(null)}
      >
        All <span className={styles.count}>{total}</span>
      </button>

      {allTags.map((tag) => (
        <button
          key={tag}
          type="button"
          className={styles.chip}
          data-tag={tag}
          data-active={active === tag}
          aria-pressed={active === tag}
          onClick={() => onChange(active === tag ? null : tag)}
        >
          {tag} <span className={styles.count}>{tagCounts.get(tag) ?? 0}</span>
        </button>
      ))}
    </div>
  )
}
